<template>
	<jet-form-section @submitted="updateProfileInformation">
		<template #title>
			Profile Information
		</template>

		<template #description>
			Update your account's profile information and email address.
		</template>

		<template #form>
				

			<!-- Name -->
			<div class="col-span-6 sm:col-span-4">
				<jet-label for="name" value="Name" />
				<jet-input id="name" type="text" class="mt-1 block w-full" v-model="form.name" autocomplete="name" />
				<jet-input-error :message="form.errors.name" class="mt-2" />
			</div>

			<!-- Email -->
			<div class="col-span-6 sm:col-span-4">
				<jet-label for="email" value="Email" />
				<jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" />
				<jet-input-error :message="form.errors.email" class="mt-2" />
			</div>

			<!-- Phone -->
			<div class="col-span-6 sm:col-span-4">
				<jet-label for="phone" value="Phone" />
				<jet-input id="phone" type="text" class="mt-1 block w-full" v-model="form.phone" />
				<jet-input-error :message="form.errors.phone" class="mt-2" />
			</div>

			<div class="col-span-6 sm:col-span-4">
				<InputFancyRadio 
					label="Notification Preferences"
					:options="contactPrefOptions"
					id="contactPref"
					v-model="form.contact_pref"
					/>
			</div>

			<div class="col-span-6 sm:col-span-4" v-if="['admin', 'team_admin'].includes(user.user_type)">
				<InputFancyRadio 
					label="New Case Preferences"
					:options="newCasePrefs"
					id="newCasePrefs"
					v-model="form.get_updates_for_new_cases"
					/>
			</div>
		</template>

		<template #actions>
			<jet-action-message :on="form.recentlySuccessful" class="mr-3">
				Saved.
			</jet-action-message>

			<jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
				Save
			</jet-button>
		</template>
	</jet-form-section>
</template>

<script>
/*
<!-- Profile Photo -->
						<div class="col-span-6 sm:col-span-4" v-if="$page.props.jetstream.managesProfilePhotos">
								<!-- Profile Photo File Input -->
								<input type="file" class="hidden"
														ref="photo"
														@change="updatePhotoPreview">

								<jet-label for="photo" value="Photo" />

								<!-- Current Profile Photo -->
								<div class="mt-2" v-show="! photoPreview">
										<img :src="user.profile_photo_url" :alt="user.name" class="rounded-full h-20 w-20 object-cover">
								</div>

								<!-- New Profile Photo Preview -->
								<div class="mt-2" v-show="photoPreview">
										<span class="block rounded-full w-20 h-20"
													:style="'background-size: cover; background-repeat: no-repeat; background-position: center center; background-image: url(\'' + photoPreview + '\');'">
										</span>
								</div>

								<jet-secondary-button class="mt-2 mr-2" type="button" @click.prevent="selectNewPhoto">
										Select A New Photo
								</jet-secondary-button>

								<jet-secondary-button type="button" class="mt-2" @click.prevent="deletePhoto" v-if="user.profile_photo_path">
										Remove Photo
								</jet-secondary-button>

								<jet-input-error :message="form.errors.photo" class="mt-2" />
						</div>
*/

import JetButton from '@/Jetstream/Button.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'

import InputFancyRadio from "@/Components/InputFancyRadio"

export default {
	components: {
		JetActionMessage,
		JetButton,
		JetFormSection,
		JetInput,
		JetInputError,
		JetLabel,
		JetSecondaryButton,
		InputFancyRadio
	},

	props: ['user'],

	data() {
		return {
			form: this.$inertia.form({
				_method: 'PUT',
				name: this.user.name,
				email: this.user.email,
				phone: this.user.phone,
				contact_pref: [0, false, '', '0', null].includes(this.user.contact_pref) ? false : (['whatsapp'].includes(this.user.contact_pref) ? 'sms' : this.user.contact_pref),
				get_updates_for_new_cases: [true, 1, '1'].includes(this.user.get_updates_for_new_cases) ? true : false,
				photo: null,
			}),

			photoPreview: null,
			contactPrefOptions: this.user.phone ? [
				{
					value: 'email',
					text: 'Email'
				},
				// {
				//   value: 'whatsapp',
				//   text: 'WhatsApp'
				// },
				{
					value: 'sms',
					text: 'SMS'
				},
				{
					value: false,
					text: 'Do not notify',
					desc: 'Selecting this option will mean you will not be updated about cases and you will need to login to check progress'
				}
			] : [
				{
					value: 'email',
					text: 'Email'
				},
				{
					value: false,
					text: 'Do not notify',
					desc: 'Selecting this option will mean you will not be updated about cases and you will need to login to check progress'
				}
			],
			newCasePrefs: [
				{
					value: true,
					text: 'Get updated about new cases'
				},
				{
					value: false,
					text: 'Don\'t notify me about new cases'
				},
			]
		}
	},

	methods: {
		updateProfileInformation() {
			if (this.$refs.photo) {
				this.form.photo = this.$refs.photo.files[0]
			}

			this.form.post(route('user-profile-information.update'), {
				errorBag: 'updateProfileInformation',
				preserveScroll: true,
				onSuccess: () => (this.clearPhotoFileInput()),
			});
		},

		selectNewPhoto() {
			this.$refs.photo.click();
		},

		updatePhotoPreview() {
			const photo = this.$refs.photo.files[0];

			if (! photo) return;

			const reader = new FileReader();

			reader.onload = (e) => {
				this.photoPreview = e.target.result;
			};

			reader.readAsDataURL(photo);
		},

		deletePhoto() {
			this.$inertia.delete(route('current-user-photo.destroy'), {
				preserveScroll: true,
				onSuccess: () => {
					this.photoPreview = null;
					this.clearPhotoFileInput();
				},
			});
		},

		clearPhotoFileInput() {
			if (this.$refs.photo?.value) {
				this.$refs.photo.value = null;
			}
		},
	},
}
</script>
